/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Queues_Team_NameInputs */

const en_tables_queues_team_name = /** @type {(inputs: Tables_Queues_Team_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team Name`)
};

const de_tables_queues_team_name = /** @type {(inputs: Tables_Queues_Team_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team Name`)
};

/**
* | output |
* | --- |
* | "Team Name" |
*
* @param {Tables_Queues_Team_NameInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_queues_team_name = /** @type {((inputs?: Tables_Queues_Team_NameInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Queues_Team_NameInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_queues_team_name(inputs)
	return de_tables_queues_team_name(inputs)
});